import { ShimmerEffect } from "@/components/shimmer";
import React from "react";
import { Card, CardHeader, CardContent } from "ui/components/card";
import { Separator } from "ui/components/separator";

const Loader = () => {
  return (
    <div className="flex flex-wrap gap-4 p-6">
      {Array.from({ length: 7 }).map((_, index) => (
        <Card className="w-96 shadow-none" key={index}>
          <CardHeader className="font-semibold">
            <ShimmerEffect className="w-32 h-6" />
          </CardHeader>
          <Separator />
          <CardContent className="text-sm flex  flex-col gap-3">
            <div className="grid grid-cols-2">
              <ShimmerEffect className="w-16 h-3" />
              <ShimmerEffect className="w-16 h-3 ml-auto" />
            </div>
            <div className="grid grid-cols-2">
              <ShimmerEffect className="w-16 h-3" />
              <ShimmerEffect className="w-16 h-3 ml-auto" />
            </div>
            <div className="grid grid-cols-2">
              <ShimmerEffect className="w-16 h-3" />
              <ShimmerEffect className="w-16 h-3 ml-auto" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default Loader;
